<template>
  <div
    ref="scroll"
    style="height: 100%">
    <slot/>
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    scrollX: {
      type: Boolean,
      default: true
    },
    scrollY: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: null
    }
  },

  mounted () {
    setTimeout(() => {
      this._initScroll()
      // this.$parent._initScrollWidth()
      // this.$parent._initVideoListScrollWidth()
    }, 20)
  },

  methods: {
    _initScroll() {
      if (!this.$refs.scroll) {
        return
      }
      this.scroll = new BScroll(this.$refs.scroll, {
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX,
        scrollY: this.scrollY,
        momentum: true,
        bounce: {
          top: false,
          bottom: true,
          left: true,
          right: true
        }
      })
    },

    refresh () {
      this.scroll && this.scroll.refresh()
    }
  },

  watch: {
    data() {
      this.refresh()
    }
  }
}
</script>

<style scoped lang='scss'>

</style>

